import React, {useCallback} from 'react';
import {shallowEqual, useDispatch, useSelector} from 'react-redux';

import DropDownCheckList from '../../SRP/DropDownCheckList/DropDownCheckList';

//GA Events
import {pushga} from 'ga-utils';
import {gaConfig} from '@stencil/hotels-config';
import {DEFAULT_RNR_OFFSET, DEFAULT_RNR_LIMIT} from '@stencil/hotels-ugc-redux/src/ugc-config';
const {DetailPageGAEvents} = gaConfig;

import {
  userReviewDetailType,
  updatePaginatorStatus,
} from '@stencil/hotels-ugc-redux/src/hotels-ugc-actions';
import {
  reviewDetailTypeSelector,
  rnrPaginatorStatus,
} from '@stencil/hotels-ugc-redux/src/hotels-ugc-selectors';

const filterOptions = [
  {name: 'See All Reviews', value: ''},
  {name: 'Experienced Traveller Only', value: 'expRev'},
  {name: 'Photo Reviews', value: 'img'},
  {name: 'Positive Reviews', value: 'pos'},
  {name: 'Negative Reviews', value: 'neg'},
  {name: 'Featured Reviews', value: 'feat'},
];

const RnrFilter = () => {
  const paginatorStatus = useSelector(rnrPaginatorStatus, shallowEqual);
  const reviewDetailType = useSelector(reviewDetailTypeSelector, shallowEqual);
  const dispatch = useDispatch();
  const {tagIds, sortBy} = reviewDetailType;

  const updateReviewDetail = useCallback(
    detailType => {
      return dispatch(userReviewDetailType(detailType));
    },
    [reviewDetailType],
  );

  const updatePaginationStatus = useCallback(
    status => {
      return dispatch(updatePaginatorStatus(status));
    },
    [paginatorStatus],
  );

  const onHandleChange = (value, name) => {
    updatePaginationStatus(paginatorStatus.concat(value));
    updateReviewDetail({
      offset: DEFAULT_RNR_OFFSET,
      limit: DEFAULT_RNR_LIMIT,
      tagIds: tagIds,
      filter: value,
      sortBy: sortBy,
    });
    pushga({
      eventCategory: DetailPageGAEvents.reviewConsumptionCategory,
      eventAction: DetailPageGAEvents.filterClicked,
      eventLabel: name,
    });
  };

  return (
    <>
      <DropDownCheckList
        options={filterOptions}
        onHandleChange={onHandleChange}
        title={'Filter By'}
        selOption={''}
        selOptionName={'See All Reviews'}
      />
    </>
  );
};

export default RnrFilter;
